<template>
  <div class="header">
      <span class="logo d-flex align-items-center">
        <v-img
              :src="cbreLogo"
              width="65px"
              height="24px"
              :alt="'CBRE'"
              @error="handleImageError"
            />
      </span> 
      <span class="agent-name d-flex">TOPS2 Actions</span>
      <div class="help-icon-wrapper">
        <HelpIcon :config="helpIconConfig" />
      </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { Bell } from 'lucide-vue-next';
import HelpIcon from '../HelpIcon.vue'
import helpIconConfigData from '../../config/help-icon.json'
import { Route, HelpCircle } from 'lucide-vue-next';
import cbreLogo from '../../../assets/cbre.png';

export default {
  name: 'Header',
  components: {
    Bell,
    Route,
    HelpIcon,
    HelpCircle
  },
  data() {
    return {
      cbreLogo,
      helpIconConfigData
    }
  },
  computed: {
    ...mapState(['notifications']),
    helpIconConfig() {
      return this.helpIconConfigData
    },
  },
  methods: {
    handleImageError(event) {
      console.log('error', event)
    }
  }
}
</script>
<style lang="css">
.header {
  display: flex;
  align-items: center;
  color: white;
  background-color: #003F2D;
  height: 53px;
  padding: 12px 14px;
  width: 100%;
  box-sizing: border-box;
  min-width: 0; /* Allow shrinking */
  overflow: hidden;
  flex-shrink: 0; /* Prevent header from shrinking */
}

.logo {
  font-family: 'Calibre-R-Medium';
  font-size: 22px;
  font-weight: 500;
  height: 100%;
  align-items: center;
  flex-shrink: 0; /* Don't shrink logo */
}

.agent-name {
  font-weight: 500;
  font-family: Calibre-R-Medium;
  font-size: 12px;
  padding-left: 6px;
  height: 100%;
  align-items: center;
  letter-spacing: 1px;
  margin-top: 3px;
  white-space: nowrap; /* Prevent text wrapping */
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1; /* Take remaining space */
  min-width: 0; /* Allow shrinking */
}

/* Comprehensive Responsive Design for Header */

/* Extra Small (Mobile Portrait - 320px and below) */
@media (max-width: 320px) {
  .header {
    height: 40px;
    padding: 6px 8px;
  }
  
  .logo .v-img {
    width: 45px !important;
    height: 18px !important;
  }
  
  .agent-name {
    font-size: 12px;
    padding-left: 4px;
    letter-spacing: 0.5px;
    margin-top: 1px;
  }
}

/* Small (Mobile Landscape - 321px to 480px) */
@media (min-width: 321px) and (max-width: 480px) {
  .header {
    height: 45px;
    padding: 8px 10px;
  }
  
  .logo .v-img {
    width: 50px !important;
    height: 20px !important;
  }
  
  .agent-name {
    font-size: 10px;
    padding-left: 5px;
    letter-spacing: 0.7px;
    margin-top: 2px;
  }
}

/* Medium (Tablet Portrait - 481px to 768px) */
@media (min-width: 481px) and (max-width: 768px) {
  .header {
    height: 48px;
    padding: 10px 12px;
  }
  
  .logo .v-img {
    width: 55px !important;
    height: 22px !important;
  }
  
  .agent-name {
    font-size: 11px;
    padding-left: 6px;
    letter-spacing: 0.8px;
    margin-top: 2px;
  }
}

/* Large (Tablet Landscape & Small Desktop - 769px to 1024px) */
@media (min-width: 769px) and (max-width: 1024px) {
  .header {
    height: 50px;
    padding: 11px 13px;
  }
  
  .logo .v-img {
    width: 60px !important;
    height: 23px !important;
  }
  
  .agent-name {
    font-size: 12px;
    padding-left: 6px;
    letter-spacing: 0.9px;
    margin-top: 3px;
  }
}

/* Extra Large (Desktop - 1025px and above) */
@media (min-width: 1025px) {
  .header {
    height: 56px;
    padding: 14px 16px;
  }
  
  .logo .v-img {
    width: 70px !important;
    height: 26px !important;
  }
  
  .agent-name {
    font-size: 13px;
    padding-left: 8px;
    letter-spacing: 1px;
    margin-top: 3px;
  }
}

/* High DPI / Retina Display Adjustments */
@media only screen and (-webkit-min-device-pixel-ratio: 2),
       only screen and (min-resolution: 192dpi),
       only screen and (min-resolution: 2dppx) {
  .agent-name {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
}

/* Landscape orientation adjustments for mobile */
@media (max-width: 768px) and (orientation: landscape) {
  .header {
    height: 42px;
    padding: 8px 10px;
  }
  
  .logo .v-img {
    width: 50px !important;
    height: 20px !important;
  }
  
  .agent-name {
    font-size: 10px;
    padding-left: 5px;
  }
  .help-icon-wrapper {
  margin-left: auto;
  flex-shrink: 0;
  z-index: 9999; /* High z-index to ensure menu appears above other elements */
}
}
</style>